<template>
  <div v-if="about">
    <!-- Investor Information -->
    <h3 class="mb-5">Social Responsibility</h3>
    <div class="h4 mb-5">顯示於AboutUs頁面</div>
    <!-- Title -->
    <label class="form-item py-5 d-flex">
      <h4 class="w-180px">Title</h4>
      <div class="flex-grow-1 flex-basis-0">
        {{ about.csr_title }}
      </div>
    </label>
    <!-- Subtitle -->
    <label class="form-item py-5 d-flex">
      <h4 class="w-180px">Subtitle</h4>
      <div class="flex-grow-1 flex-basis-0">
        {{ about.csr_subtitle }}
      </div>
    </label>
    <!-- Description：前台未使用，隱藏 -->
    <label v-if="false" class="form-item py-5 d-flex">
      <h4 class="w-180px">Description</h4>
      <div class="flex-grow-1 flex-basis-0">
        {{ about.csr_description }}
      </div>
    </label>
    <!-- Call to Action：前台未使用，隱藏 -->
    <label v-if="false" class="form-item py-5 d-flex">
      <h4 class="w-180px">Call to Action</h4>
      <div class="flex-grow-1 flex-basis-0">
        {{ about.csr_call_to_action }}
      </div>
    </label>
    <!-- img uploader -->
    <div class="px-5 py-5 d-flex">
      <div class="w-180px">
        <h4 class="mb-10px">Visual</h4>
      </div>
      <div class="flex-grow-1">
        <div
          class="w-305px h-187px bg-cover bg-center ml-auto"
          :style="{
            'background-image': `url(${about.csr_visual})`,
            'border-radius': '6.2px',
            'background-size': 'contain',
          }"
        ></div>
      </div>
    </div>

    <!-- CSR Highlight：前台未使用，隱藏 -->
    <template v-if="false">
    <h3 class="my-5">CSR Highlight</h3>
    <div class="h4 mb-5">可擴充</div>
    <div class="form-item py-5" v-for="(item, i) in about.csr_highlight" :key="i">
      <!-- Highlight -->
      <div class="d-flex align-center">
        <h5 class="w-174px pr-5">CSR Highlight {{ i + 1 }}</h5>
        <div class="flex-grow-1">
          {{ item.title }}
        </div>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    about: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style></style>
